import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules/:id`,
  options: {
    method: 'PATCH'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/patch.js